module.exports = __webpack_public_path__ + "static/media/earned-arrow.c2f3ec10.svg";